export const findThumbnailUrl = images => {
  if (!images || !images[0]) {
    return '';
  }
  const i = images.filter(img => img && img.sizes && img.sizes.thumbnail && img.sizes.thumbnail.url)[0];
  return i ? i.sizes.thumbnail.url : images[0].image_url;
};
